import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import qs from 'query-string';
import Header from '@/layout/header';
import Content from '@/components';
import { EN_US_LOCALE } from '@/locale/locales/en_US';
import { registerLocale } from '@/locale';
import './index.less';

registerLocale('en_US', EN_US_LOCALE);

const Page = () => {
  const [title, changeTitle] = useState('Resume Generator');
  useEffect(() => {
    const search = typeof window !== 'undefined' && window.location.search;
    const query = qs.parse(search);
    if (query.user) {
      changeTitle(`${query.user}'s resume`);
    }
  }, []);

  return (
    <React.Fragment>
      <Helmet>
        
      <script href="https://cdn.jsdelivr.net/npm/html2canvas/dist/html2canvas.min.js"/>
        <title>{title}</title>
      </Helmet>
      <Header />
      <Content />
    </React.Fragment>
  );
};

export default Page;
